<template>
    <div class="card centered-form" style="position: relative;">
        <!-- We would need to disable the autosave functionality to have a legit "Cancel" -->
        <!-- <BackLink>
          <i class="fa fa-close fa-fw fa-2x" style="position: absolute; right: 0; top: 0;"
          @click="clear()"
          title="Cancel"
          ></i>
        </BackLink> -->
        <h1>Edit a Trip</h1>
        <table>
            <tr>
                <td>
                    <span>
                        Stock Number:
                    </span>
                </td>
                <td>
                    <vehicle-select @change="update('stock_num', $event)" :currentValue="trip.stock_num"/>
                </td>
            </tr>
            <tr>
                <td>
                    <span>
                        Vehicle From:
                    </span>
                </td>
                <td>
                    <location-select @change="update('from', $event)" :currentValue="trip.from"/>
                </td>
            </tr>
            <tr>
                <td>
                    <span>
                        Vehicle To:
                    </span>
                </td>
                <td>
                    <location-select @change="update('to', $event)" :currentValue="trip.to"/>
                </td>
            </tr>
            <tr>
                <td>
                    Skip car wash?
                </td>
                <td>
                    <v-input type="checkbox" @change="update('skip_wash', $event)" :currentValue="trip.skip_wash"> 
                        Yes
                    </v-input>
                </td>
            </tr>
            <tr>
                <td>
                      Guest Waiting?
                </td>
                <td>
                    <v-input type="checkbox" @change="update('waiter', $event)" :currentValue="trip.waiter"> 
                        Yes
                    </v-input>
                </td>
            </tr>
            <tr>
                <td>
                    Guest Name:
                </td>
                <td>
                    <guest-name :currentValue="trip.guest_name" editonly @change="update('guest_name', $event)"/>
                </td>
            </tr>
            <tr>
                <td>
                    Appt Time:
                </td>
                <td>
                    <appt-time editonly  @change="update('appt_time', $event)" :currentValue="trip.appt_time"/>
                </td>
            </tr>
            <tr>
                <td>
                    <span>
                        Requesting Manager:
                    </span>
                </td>
                <td>
                    <user-select @change="update('mgr_requested', $event)" :currentValue="$privateReactiveStore.getManager(trip.mgr_requested)" :options="managers" :defaultSelection="user && user.id"/>
                </td>
            </tr>
            <tr>
                <td>
                    Product Specialist:
                </td>
                <td>
                    <user-select @change="update('product_specialist', $event)" :currentValue="$privateReactiveStore.getProductSpecialist(trip.product_specialist)" :options="productSpecialists"/>
                </td>
            </tr>
            <tr>
                <td>
                    Driver:
                </td>
                <td>
                    <driver-select :trip="trip"/>
                </td>
            </tr>
            <tr>
                <td>
                    Notes:
                </td>
                <td>
                    <trip-note-list :trip="trip"/>
                </td>
            </tr>
        </table>
        <br/>
        <back-link>
            <v-button :style="{width: '100%'}">
                <i class="fa fa-check"></i>&nbsp;Done Editing
            </v-button>
        </back-link>
        <table>
            <tr>
                <td>
                    Created Time:
                </td>
                <td>
                    {{ trip.created_at | formatDate }}
                </td>
                <td>
                    Assigned Time:
                </td>
                <td>
                    {{ trip.assigned_time | formatDate }}
                </td>
            </tr>
            <tr>
                <td>
                    Accessed Vehicle Time:
                </td>
                <td>
                    {{ trip.driver_accessing_vehicle_time | formatDate }}
                </td>
                <td>
                    Leaving Time:
                </td>
                <td>
                    {{ trip.driver_leaving_time | formatDate }}
                </td>
            </tr>
            <tr>
                <td>
                    Completed Time:
                </td>
                <td>
                    {{ trip.delivered | formatDate }}
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import epoch from 'epoch.js'
    import VehicleSelect from './VehicleSelect.vue'
    import LocationSelect from './LocationSelect.vue'
    import UserSelect from './UserSelect.vue'
    import DriverSelect from './DriverSelect.vue'
    import GuestName from './GuestName.vue'
    import ApptTime from './ApptTime.vue'
    import TripNoteList from './TripNoteList.vue'
    import BackLink from './BackLink.vue'

    export default {
        props: [
            'trip'
        ],
        components: {
            'vehicle-select': VehicleSelect,
            'location-select': LocationSelect,
            'user-select': UserSelect,
            'driver-select': DriverSelect,
            'guest-name': GuestName,
            'appt-time': ApptTime,
            'trip-note-list': TripNoteList,
            'back-link': BackLink
        },
        methods: {
            update (key, value) {
                console.log("IN UPDATE WITH " + key + " " + JSON.stringify(value));
                
                this.$eventHub.$emit('updateTrip', this.trip.id, {[key]: value});
            }
        },
        computed: {
            managers () {
                return this.$privateReactiveStore.getManagers()
            },
            user () {
                return this.$privateReactiveStore.getUser()
            },
            productSpecialists () {
                let a = this.$privateReactiveStore.getProductSpecialists().slice()
                let b = this.$privateReactiveStore.getManagers().slice()
                let c = a.concat(b)
                
                c.sort()
                
                return c
            },
            drivers () {
                let drivers = []
                let separatorAlready = false

                // Add all drivers one by one
                for (let i = 0; i < this.$privateReactiveStore.drivers.length; i++) {
                    if (!separatorAlready && this.$privateReactiveStore.drivers[i].role !== 'driver') {
                        // Insert a separator between drivers and backup drivers
                        drivers.push({ diabled: "1", full_name: '──────────', id: ''});
                        separatorAlready = true
                    }

                    drivers.push(this.$privateReactiveStore.drivers[i])
                }

                return drivers
            }
        },
    }
</script>

<style scoped lang="less">
    h1 {
        text-align: center;
        padding-top: 0;
    }
    table {
        position: relative;
        width: fit-content;
    }
    .centered-form {
        min-width: -moz-fit-content;
        min-width: fit-content;
        max-width: 600px;
        margin: auto;
        margin-top: 1em;
        padding: 2em;
        padding-top: 1em;
        overflow: visible;
    }
    .centered-form * {
        flex: 1;
    }
</style>
